import Api from "@/services/api";
// import { extractUnderscore } from "@/services/helpers";
import { ActionContext } from "vuex";

export default {
  namespaced: true,
  state: {
    currentPage: 1,
    totalPages: null,
    totalData: null,
    taskAreas: [],
    jobTypes: [],
    employmentTypes: [],
    teams: [],
    tabId: 0,
    costCenters: [],
    positions: [],
    companies: [],
    languages: [],
    businessArea: [],
    iconCategory: [],
    defaultCollaborators: [],
    isConfigurationsUpdate: {},
  },

  mutations: {
    SET_TASK_AREAS_TO_STATE(state: any, payload: any) {
      state.taskAreas = payload;
    },
    SET_JOB_TYPES_TO_STATE(state: any, payload: any) {
      state.jobTypes = payload;
    },
    SET_EMPLOYMENT_TYPES_TO_STATE(state: any, payload: any) {
      state.employmentTypes = payload;
    },
    SET_TEAMS_TO_STATE(state: any, payload: any) {
      state.teams = payload;
    },
    SET_CURRENT_TAB_TO_STATE(state: any, payload: any) {
      state.tabId = payload;
    },
    SET_COMPANIES_TO_STATE(state: any, payload: any) {
      state.companies = payload;
    },
    SET_POSITIONS_TO_STATE(state: any, payload: any) {
      state.positions = payload;
    },
    SET_COST_CENTERS_TO_STATE(state: any, payload: any) {
      state.costCenters = payload;
    },
    SET_LANGUAGES_TO_STATE(state: any, payload: any) {
      state.languages = payload;
    },
    SET_BUSINESS_AREA_TO_STATE(state: any, payload: any) {
      state.businessArea = payload;
    },
    SET_ICON_CATEGORY_TO_STATE(state: any, payload: any) {
      state.iconCategory = payload;
    },
    SET_DEFAULT_COLLABORATORS_TO_STATE(state: any, payload: any) {
      state.defaultCollaborators = payload;
    },
    SET_CURRENT_PAGE_TO_STATE(state: any, payload: any) {
      state.currentPage = payload;
    },
    SET_TOTAL_PAGES_TO_STATE(state: any, payload: any) {
      state.totalPages = payload;
    },
    SET_CONFIGURATIONS_UPDATE(state: any, payload: any) {
      state.isConfigurationsUpdate = {
        ...state.isConfigurationsUpdate,
        ...payload,
      };
    },
  },
  getters: {
    isTaskAreas(state: any) {
      return state.taskAreas;
    },
    isCurrentTab(state: any) {
      return state.tabId;
    },
    isCurrentPage(state: any) {
      return state.currentPage;
    },
    isTotalPages(state: any) {
      return state.totalPages;
    },
    isJobTypes(state: any) {
      return state.jobTypes;
    },
    isEmploymentTypes(state: any) {
      return state.employmentTypes;
    },
    isTeams(state: any) {
      return state.teams;
    },
    isPositions(state: any) {
      return state.positions;
    },
    isCompanies(state: any) {
      return state.companies;
    },
    isCostCenters(state: any) {
      return state.costCenters;
    },
    isLanguages(state: any) {
      return state.languages;
    },
    isBusinessArea(state: any) {
      return state.businessArea;
    },
    isIconCategory(state: any) {
      return state.iconCategory;
    },
    isDefaultCollaborators(state: any) {
      return state.defaultCollaborators;
    },
    isLanguagesTitle(state: any) {
      return state.languages.map((language: any) => language.title);
    },
    isCompaniesTitle(state: any) {
      return state.companies.map((company: any) => company.title);
    },
    isPositionsTitle(state: any) {
      return state.positions.map((position: any) => position.title);
    },
    isTeamsTitle(state: any) {
      return state.teams.map((team: any) => team.title);
    },
    isBusinessAreaTitle(state: any) {
      return state.businessArea.map((area: any) => area.title);
    },
    isIconCategoryTitle(state: any) {
      return state.iconCategory.map((category: any) => category.title);
    },
    isEmploymentTypesTitle(state: any) {
      return state.employmentTypes.map(
        (employeeType: any) => employeeType.title
      );
    },
    isConfigurationsUpdate(state: any) {
      return state.isConfigurationsUpdate;
    },
  },
  actions: {
    getAllConfigurationLanguages(
      context: ActionContext<any, any>,
      payload: any
    ) {
      Api()
        .get(`/configuration/general/get-general/Languages/${payload}/`)
        .then((response: any) => {
          if (response.data.status === "success") {
            const responseData = response.data;
            context.commit("SET_LANGUAGES_TO_STATE", responseData.data);
            context.commit(
              "SET_CURRENT_PAGE_TO_STATE",
              responseData.current_page
            );
            context.commit("SET_TOTAL_PAGES_TO_STATE", responseData.total_data);
          }
        });
    },
    getAllConfigurationTeams(context: ActionContext<any, any>, payload: any) {
      Api()
        .get(`/configuration/general/get-general/Teams/${payload}/`)
        .then((response: any) => {
          if (response.data.status === "success") {
            const responseData = response.data;
            context.commit("SET_TEAMS_TO_STATE", responseData.data);
            context.commit(
              "SET_CURRENT_PAGE_TO_STATE",
              responseData.current_page
            );
            context.commit("SET_TOTAL_PAGES_TO_STATE", responseData.total_data);
          }
        });
    },
    getAllConfigurationCompanies(
      context: ActionContext<any, any>,
      payload: any
    ) {
      Api()
        .get(`/configuration/general/get-general/Companies/${payload}/`)
        .then((response: any) => {
          if (response.data.status === "success") {
            const responseData = response.data;
            context.commit("SET_COMPANIES_TO_STATE", responseData.data);
            context.commit(
              "SET_CURRENT_PAGE_TO_STATE",
              responseData.current_page
            );
            context.commit("SET_TOTAL_PAGES_TO_STATE", responseData.total_data);
          }
        });
    },
    getAllConfigurationPositions(
      context: ActionContext<any, any>,
      payload: any
    ) {
      Api()
        .get(`/configuration/general/get-general/Positions/${payload}/`)
        .then((response: any) => {
          if (response.data.status === "success") {
            const responseData = response.data;
            context.commit("SET_POSITIONS_TO_STATE", responseData.data);
            context.commit(
              "SET_CURRENT_PAGE_TO_STATE",
              responseData.current_page
            );
            context.commit("SET_TOTAL_PAGES_TO_STATE", responseData.total_data);
          }
        });
    },
    getAllConfigurationEmploymentTypes(
      context: ActionContext<any, any>,
      payload: any
    ) {
      Api()
        .get(`/configuration/general/get-general/Employment Types/${payload}/`)
        .then((response: any) => {
          if (response.data.status === "success") {
            const responseData = response.data;
            context.commit("SET_POSITIONS_TO_STATE", responseData.data);
            context.commit(
              "SET_CURRENT_PAGE_TO_STATE",
              responseData.current_page
            );
            context.commit("SET_TOTAL_PAGES_TO_STATE", responseData.total_data);
          }
        });
    },
    getAllConfigurationTypes(
      context: ActionContext<any, any>,
      payload: {
        configType: string;
        setter: string;
      }
    ) {
      Api()
        .get(`/configuration/general/get-general/${payload.configType}/`)
        .then((response: any) => {
          if (response.data.status === "success") {
            const responseData = response.data;
            context.commit(payload.setter, responseData.data);
            context.commit(
              "SET_CURRENT_PAGE_TO_STATE",
              responseData.current_page
            );
            context.commit("SET_TOTAL_PAGES_TO_STATE", responseData.total_data);
          }
        });
    },
    getAllDefaultCollaborators(context: ActionContext<any, any>) {
      Api()
        .get("/configuration/default-collaborators/get-responsible-persons/")
        .then((response: any) => {
          if (response.data.status === "success") {
            const responseData = response.data;
            context.commit(
              "SET_DEFAULT_COLLABORATORS_TO_STATE",
              responseData.data
            );
            context.commit(
              "SET_CURRENT_PAGE_TO_STATE",
              responseData.current_page
            );
            context.commit("SET_TOTAL_PAGES_TO_STATE", responseData.total_data);
          }
        });
    },

    getAllCostCenters(context: ActionContext<any, any>, page: any) {
      Api()
        .post(`/configuration/projects/all-cost-centers/${page}/`)
        .then((response) => {
          const payload = response.data;
          context.commit("SET_COST_CENTERS_TO_STATE", payload.data);
          context.commit("SET_CURRENT_PAGE_TO_STATE", payload.current_page);
          context.commit("SET_TOTAL_PAGES_TO_STATE", payload.total_data);
        });
    },
    getAllCostCentersWithoutPagination(context: ActionContext<any, any>) {
      Api()
        .get(`/configuration/projects/all-cost-centers/`)
        .then((response) => {
          const payload = response.data;
          context.commit("SET_COST_CENTERS_TO_STATE", payload.data);
        });
    },
  },
};
